import cadviewer from "cadviewer";
import JQ from "jquery";
import { useCallback, useContext, useEffect, useRef } from "react";
import { CadviewerContext } from "../../../context/Cadviewer.Context";
import useConfig from "../../../demos/hooks/useConfig";

export const CADViewerCustomCanvasVizQueryBrookfield = () => {
  const { config } = useConfig();
  const {
    currentCanvasInstance,
    plansInfo,
    distanceData,
    setMultiSelectArray,
  } = useContext(CadviewerContext);

  /////////  CANVAS CONTROL METHODS START

  ///  HERE ARE ALL THE CUSTOM TEMPLATES TO DO STUFF ON THE CANVAS

  var generic_canvas_flag_first_click_rectangle = false;
  var generic_canvas_flag_rectangle = false;
  var tPath_r = "";
  var cvjs_RubberBand: any;
  var cvjs_firstX = 0;
  var cvjs_firstY = 0;
  var cvjs_lastX = 0;
  var cvjs_lastY = 0;

  var selected_handles: any; // this is just to show that you can have multiple handles
  var handle_selector = false;
  var current_selected_handle = "";


  var selectedList: any = [];

  // we return the selected list
  const returnSelectedSpaces = useCallback(() => {


    var multiSelectList = cadviewer.cvjs_getMultiSelectArray() as any[];
    var returnList: any = [];

    // loop over selectedList and add to returnList
    /* we do not need drag select as we are using multiselect only

    var dragSelectList = selectedList as any[];

    for (var i = 0; i < dragSelectList.length; i++) {
      returnList.push({"SpaceID" :dragSelectList[i]});
    }
    */
    for (var i = 0; i < multiSelectList.length; i++) {
      returnList.push({ "SpaceID": multiSelectList[i]?.SpaceID });
    }
    return returnList;

  }, [currentCanvasInstance]);






  const cadviewerCanvasMethod01 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_drag(
      generic_start_method_01,
      generic_stop_method_01,
      generic_move_method_01,
      ""
    );
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod02 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_click(
      generic_mousemove_method_01,
      generic_mousedown_method_01,
      generic_mouseup_method_01,
      generic_dblclick_method_01,
      ""
    );
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod03 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_click(
      generic_make_rect_mousemove_method,
      generic_make_rect_mousedown_method,
      generic_make_rect_mouseup_method,
      "",
      generic_make_rect_init_method
    );
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod04 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_drag(
      generic_drag_rect_start,
      generic_drag_rect_stop,
      generic_drag_rect_move,
      ""
    );
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod05 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_drag(
      select_drag_rect_start,
      select_drag_rect_stop,
      select_drag_rect_move,
      ""
    );
  }, [currentCanvasInstance]);




  // selected and highlight spaces - new 

  var highlight_blue_borders = {
    fill: '#fff',
    "fill-opacity": 0.01,
    stroke: '#003366',           // midnight blue 003366 ,    #0c8dff
    'stroke-width': 4.0,
    'stroke-opacity': 1.0,
    'stroke-linejoin': 'round'
  };


  var default_state = {
    fill: '#fff',
    "fill-opacity": 0.01,
    stroke: '#FFF',           // midnight blue 003366 ,    #0c8dff
    'stroke-width': 0.1,
    'stroke-opacity': 1.0,
    'stroke-linejoin': 'round'
  };


  var mouseover_state = {
    fill: '#fff',
    "fill-opacity": 0.01,
    stroke: '#FFF',           // midnight blue 003366 ,    #0c8dff
    'stroke-width': 0.1,
    'stroke-opacity': 1.0,
    'stroke-linejoin': 'round'
  };




  const cadviewerCanvasMethod05A = useCallback(() => {


    cadviewer.cvjs_executeCustomCanvasMethod_drag(
      select_drag_rect_start,
      select_drag_rect_stop_highlight,
      select_drag_rect_move,
      ""
    );
  }, [currentCanvasInstance]);

  




  // clear spaces - new

  const cadviewerCanvasVizquery01 = useCallback(() => {
    cadviewer.cvjs_clearSpaceLayer();
    cadviewer.cvjs_clearMultiSelectArrays(); // clear CADViewer multiselect

    selectedList = []; // clear previous selection
    setMultiSelectArray([]); // clear context

  }, [currentCanvasInstance, setMultiSelectArray]);


  const cadviewerCanvasVizquery01X = useCallback(() => {
    cadviewer.cvjs_removeMultiSelectItem("1848")
  }, [currentCanvasInstance, setMultiSelectArray]);





  //  retrieve multiselect array  - new

  const cadviewerCanvasVizquery01A = useCallback(() => {
    window.alert("MultiSelected Spaces: " + JSON.stringify(cadviewer.cvjs_getMultiSelectArray()));
  }, [currentCanvasInstance]);


  const cadviewerCanvasVizquery01B = useCallback(() => {

    // we can add into one list
    //var multiSelectList = JSON.stringify(cadviewer.cvjs_getMultiSelectArray());
    //var dragSelectList = JSON.stringify(selectedList);

    var newselectedList: any = [];

    newselectedList = returnSelectedSpaces();
    window.alert("MultiSelected/Drag Selected Spaces: " + JSON.stringify(newselectedList));
    //    window.alert(" Drag Selected Spaces: "+JSON.stringify(selectedList));
  }, [currentCanvasInstance]);

  // new - end retrieve multiselect array



  const cadviewerCanvasVizquery02 = useCallback(() => {
    cadviewer.cvjs_drawRedline_Freehand(currentCanvasInstance as string);
  }, [currentCanvasInstance]);

  const cadviewerCanvasVizquery03 = useCallback(() => {
    cadviewer.cvjs_drawRedline_Freehand(currentCanvasInstance as string);
  }, [currentCanvasInstance]);

  const cadviewerCanvasVizquery04 = useCallback(() => {
    config.ShowInformativeBottomPanel = false;
  }, [currentCanvasInstance]);

  const cadviewerCanvasVizquery05 = useCallback(() => {
    config.ShowInformativeBottomPanel = true;
  }, [currentCanvasInstance]);

  const cadviewerCanvasVizquery06 = useCallback(() => {
    cadviewer.cvjs_clearMultiSelectArrays();
  }, [currentCanvasInstance]);

  var highlight_red = {
    fill: "#fa8072",
    "fill-opacity": 0.8,
    stroke: "#8B0000", // #8B0000   #fa8072    // red
    "stroke-width": 2.0, //
    "stroke-opacity": 1,
    "stroke-linejoin": "round",
  };

  var highlight_green = {
    fill: "#32CD32", // 0dff8a
    "fill-opacity": 0.8,
    stroke: "#228B22", // 0dff8a green
    "stroke-width": 2.0,
    "stroke-opacity": 1,
    "stroke-linejoin": "round",
  };

  var highlight_blue = {
    fill: "#0c8dff",
    "fill-opacity": 0.8,
    stroke: "#003366", // midnight blue 003366 ,    #0c8dff
    "stroke-width": 2.0,
    "stroke-opacity": 1.0,
    "stroke-linejoin": "round",
  };

  var highlight_yellow = {
    fill: "#fafa00", //  #FFFCBB yellow
    "fill-opacity": 0.8,
    stroke: "#FFD300", //  orange
    "stroke-width": 2.0,
    "stroke-opacity": 1,
    "stroke-linejoin": "round",
  };

  var highlight_purple = {
    fill: "#ff00dd",
    "fill-opacity": 0.8,
    stroke: "#800080", //  purple          #ff00dd
    "stroke-width": 2.0,
    "stroke-opacity": 1,
    "stroke-linejoin": "round",
  };

  const cadviewerCanvasVizquery07 = useCallback(() => {
    var returnArray = cadviewer.cvjs_getMultiSelectArray();
    console.log("finishMultiselect:" + JSON.stringify(returnArray));

    //  var returnArray = cvjs_multiSelectFinish();
    //  window.alert("finishMultiselect:"+JSON.stringify(mySpaceArray));

    cadviewer.cvjs_clearMultiSelectArrays();

    setMultiSelectArray([]);

    var my_test_counter = 0;

    for (var space in returnArray) {
      try {
        my_test_counter++;
        if (my_test_counter > 8) my_test_counter = 1;

        console.log(
          "loop:" +
          space +
          " " +
          returnArray[space].SpaceID +
          "  " +
          my_test_counter
        );

        var thispace = returnArray[space].SpaceID;

        console.log(thispace + " thispace");

        var planInfo = (plansInfo?.spaces ?? []).find(
          (planInfo) =>
            planInfo["spaceNumber"].replaceAll(".", "_").replaceAll(" ", "_") ==
            thispace
        );

        //console.log(space+" planInfo", planInfo);

        //console.log(space+" planInfo", planInfo);

        if (planInfo) {
          //console.log("ALL DATA: ("+planInfo["detailTabs"][0]["detail"]["DBA"]+"): "+JSON.stringify(planInfo["detailTabs"][0]["detail"]));

          //console.log(space+" planInfo", planInfo);
          console.log("Space Number:", thispace);
          console.log(
            "Deal Type:",
            planInfo["detailTabs"][0]["detail"]["Deal Type"]
          );
          console.log(
            "Date of Possession (Mutually Agreed):",
            planInfo["detailTabs"][0]["detail"][
            "Date of Possession (Mutually Agreed)"
            ]
          );
          console.log(
            "Occupancy Costs:",
            planInfo["detailTabs"][0]["detail"]["Occupancy Cost"]
          );

          if (my_test_counter == 1)
            cadviewer.cvjs_highlightSpace(thispace, highlight_red);
          if (my_test_counter == 2)
            cadviewer.cvjs_highlightSpace(thispace, highlight_blue);
          if (my_test_counter == 3)
            cadviewer.cvjs_highlightSpace(thispace, highlight_green);
          if (my_test_counter == 4)
            cadviewer.cvjs_highlightSpace(thispace, highlight_purple);

          if (my_test_counter == 5)
            cadviewer.cvjs_hatchSpace(
              thispace,
              "pattern_45degree_crosshatch_fine",
              "#550055",
              0.5
            );
          if (my_test_counter == 6)
            cadviewer.cvjs_hatchSpace(
              thispace,
              "pattern_45degree_standard",
              "#AA2200",
              0.5
            );
          if (my_test_counter == 7)
            cadviewer.cvjs_hatchSpace(
              thispace,
              "pattern_135degree_wide",
              "#0055BB",
              0.5
            );
          if (my_test_counter == 8)
            cadviewer.cvjs_hatchSpace(
              thispace,
              "pattern_90degree_wide",
              "#220088",
              0.5
            );
        }
      } catch (err) {
        console.log("error", err);
      }
    }
  }, [currentCanvasInstance]);

  // AI stuff

  const cadviewerCanvasVizquery08 = useCallback(() => {
    var proximity_search = "";
    var target_type = "";
    var target_name = "";
    var max_distance = "";
    var distance_unit = "";
    var is_within = false;
    var avilablity = "";
    var min_size = 0;
    var min_area = 0;

    var thispace = "";

    var my_test_counter = 1;

    var aijsonresponsestring = `{
    "action_type": "proximity_search",
    "parameters": {
      "target_type": "storefront",
      "max_distance": 100,
      "distance_unit": "meters",
      "is_within": true,
      "min_area": 275,
      "area_unit": "square_meters",
      "target_name": "Morrisons",
      "availability": "available"
    },
    "description": "Find all available storefronts over 275m2 within 100 meters from Morrisons"
  }`;

    console.log("internalCADViewerAICallback01 Call: ", aijsonresponsestring);

    var aijsonresponse = JSON.parse(aijsonresponsestring);

    console.log("internalCADViewerAICallback01: JSON.parse ", aijsonresponse);

    console.log("aijsonresponse.action_type: ", aijsonresponse.action_type);
    console.log(
      "aijsonresponse.parameters,target_name: ",
      aijsonresponse.parameters.target_name
    );
    console.log(
      "aijsonresponse.parameters,target_type: ",
      aijsonresponse.parameters.target_type
    );

    var myReturnArray = [];
    var myReturnArray2 = [];
    var myReturnArray3 = [];

    try {
      // Check if the response has elements

      if (aijsonresponse.action_type === "proximity_search") {
        cadviewer.cvjs_clearSpaceLayer();

        console.log("cleared layers: ");

        proximity_search = aijsonresponse.parameters.proximity_search;
        target_type = aijsonresponse.parameters.target_type;
        target_name = aijsonresponse.parameters.target_name;
        max_distance = aijsonresponse.parameters.max_distance;
        distance_unit = aijsonresponse.parameters.distance_unit;
        is_within = aijsonresponse.parameters.is_within;
        avilablity = aijsonresponse.parameters.avilablity;
        min_area = parseFloat(aijsonresponse.parameters.min_area);

        console.log("target_name: ", target_name);
        console.log("target_name: ", target_type);
        console.log("max_distance: ", max_distance);
        console.log("plansInfo: ", plansInfo);

        // we need a to check if the there are incorrect reponse date in the JSON
        // if the target_name is empty, we need to set it to the target_type

        if (target_name == "") {
          target_name = target_type;
          console.log("we have changed target_name: ", target_name);
        }

        target_name = target_name.toLowerCase();
        //target_name = "Morrisons";
        console.log("target_name: ", target_name);
        //

        var planInfo = (plansInfo?.spaces ?? []).find(
          (planInfo) => planInfo["spaceHeader"].toLowerCase() == target_name
        );

        console.log("planInfo: ", planInfo);

        if (planInfo) {
          thispace = planInfo["spaceNumber"]
            .replaceAll(".", "_")
            .replaceAll(" ", "_");

          //console.log("ALL DATA: ("+planInfo["detailTabs"][0]["detail"]["DBA"]+"): "+JSON.stringify(planInfo["detailTabs"][0]["detail"]));

          console.log("thispace: " + thispace);

          console.log("Space Number:", thispace);
          console.log(
            "Deal Type:",
            planInfo["detailTabs"][0]["detail"]["Deal Type"]
          );
          console.log(
            "Date of Possession (Mutually Agreed):",
            planInfo["detailTabs"][0]["detail"][
            "Date of Possession (Mutually Agreed)"
            ]
          );
          console.log(
            "Occupancy Costs:",
            planInfo["detailTabs"][0]["detail"]["Occupancy Cost"]
          );

          // the source store is highlighted in red
          cadviewer.cvjs_highlightSpace(thispace, highlight_red);

          /*

            if (my_test_counter==1)
            if (my_test_counter==2)
              cadviewer.cvjs_highlightSpace(thispace, highlight_blue); 
            if (my_test_counter==3)
              cadviewer.cvjs_highlightSpace(thispace, highlight_green); 
            if (my_test_counter==4)
              cadviewer.cvjs_highlightSpace(thispace, highlight_purple); 

            if (my_test_counter==5)
              cadviewer.cvjs_hatchSpace(thispace, "pattern_45degree_crosshatch_fine", "#550055" , 0.5);
            if (my_test_counter==6)
              cadviewer.cvjs_hatchSpace(thispace, "pattern_45degree_standard", "#AA2200" , 0.5);
            if (my_test_counter==7)
              cadviewer.cvjs_hatchSpace( thispace, "pattern_135degree_wide", "#0055BB" , 0.5);
            if (my_test_counter==8)
              cadviewer.cvjs_hatchSpace( thispace, "pattern_90degree_wide", "#220088" , 0.5);


            */

          // let us make an array with min size ;
          // I want to loop over plansInfo and find all the spaces that are within the max_distance
          //var myarea =0;

          for (var key in plansInfo?.spaces ?? []) {
            var myarea = plansInfo?.spaces[key].detailTabs[0].detail.GLA;

            console.log("myarea: ", myarea);

            var myareastring = myarea!.toString();
            myareastring = myareastring.replace(" m2", "");
            myarea = parseFloat(myareastring);
            console.log("myarea replaced m2: ", myarea);
            console.log("myarea: ", myarea, " min_size: ", min_area);

            if (myarea == undefined) {
            } else {
              //myarea = myarea.toString().replace(" m2", "");
            }

            if (myarea != undefined && myarea > min_area) {
              console.log("in loop myarea: ", myarea, " min_size: ", min_size);
              myReturnArray.push({
                SpaceID: plansInfo?.spaces[key].spaceNumber,
                Area: myarea,
                Tenant: plansInfo?.spaces[key].spaceHeader,
              });
            }
          }

          console.log("myReturnArray: ", myReturnArray);
          console.log(
            "JSON.stringify myReturnArray: ",
            JSON.stringify(myReturnArray)
          );

          // let us check the distances
          myReturnArray2 = [];

          var distanceInfo = (distanceData?.spaces ?? []).find(
            (distanceInfo) => distanceInfo["spaceNumber"] == thispace
          );

          if (distanceInfo) {
            var thisdistance;
            console.log("distanceInfo: ", distanceInfo);
            var spaces = distanceInfo["distances"];
            console.log("distanceInfo: ", spaces);

            for (var key2 in spaces ?? []) {
              //if (flag) break;
              thisdistance = spaces[key2].Distance;
              //console.log("thisdistance/1000.0: ", thisdistance/1000.0); - no need to divide by 1000.0
              if (thisdistance < parseFloat(max_distance)) {
                console.log("found distance: ", thisdistance);
                myReturnArray2.push({
                  SpaceID: spaces[key2].spaceNumber,
                  Distance: thisdistance,
                });
              }
            }

            console.log("myReturnArray2: ", myReturnArray2);
            console.log(
              "JSON.stringify myReturnArray2: ",
              JSON.stringify(myReturnArray2)
            );
          }

          myReturnArray3 = [];

          for (var key in myReturnArray) {
            for (var key2 in myReturnArray2) {
              if (myReturnArray[key].SpaceID == myReturnArray2[key2].SpaceID) {
                console.log(
                  "found match: ",
                  myReturnArray[key].SpaceID,
                  " ",
                  myReturnArray2[key2].SpaceID
                );
                myReturnArray3.push({
                  SpaceID: myReturnArray[key].SpaceID,
                  Area: myReturnArray[key].Area,
                  Tenant: myReturnArray[key].Tenant,
                  Distance: myReturnArray2[key2].Distance,
                });
              }
            }
          }

          console.log("myReturnArray3: ", myReturnArray3);
          console.log(
            "JSON.stringify myReturnArray3: ",
            JSON.stringify(myReturnArray3)
          );

          //  */

          for (var key in myReturnArray3) {
            cadviewer.cvjs_highlightSpace(
              myReturnArray3[key].SpaceID ?? "",
              highlight_green
            );
          }

          return myReturnArray3;

          /*

{
  "data" : {
    "planType" : "Lease Plan",
    "propertyNumber" : "",
    "planName" : "",
    "spaces" : [
      {
      "spaceNumber": "2408A-A", 
      "distances": [
        {
        "spaceNumber": "2410",
        "Distance": 10878.9
        },
        {
        "spaceNumber": "2406",
        "Distance": 30001.1
        },
        {
        "spaceNumber": "2408A",
        "Distance": 16024.8
        },
        {
        "spaceNumber": "2328",
        "Distance": 51354.3
        },
        {
        "spaceNumber": "2326",
        "Distance": 62495.7
        },

*/
        }
      }
    } catch (e) {
      window.console.log("Error parsing AI JSON response: ", e);
    }
  }, [currentCanvasInstance, plansInfo, distanceData]);

  // AI update
  const cadviewerCanvasVizquery09 = useCallback(() => {
    const result: any = {
      targetPlanInfo: undefined,
      searchResults: [],
    };

    // proximity search
    let action_type = "";
    let target_type = "";
    let max_distance = "";
    let min_distance = "";
    let distance_unit = "";
    let is_within_distance = false;
    let is_within_area = false;
    let availability = "";
    let min_area = 0;
    let max_area = 0;
    let area_unit = "";
    let target_name = "";
    let thispace = "";

    //const aijsonresponse = JSON.parse(aijsonresponsestring);
    const myReturnArray: Array<{
      SpaceID: string | undefined;
      Area: number | undefined;
      Tenant: string | undefined;
    }> = [];
    const myReturnArray2: Array<{
      SpaceID: string | undefined;
      Distance: number | undefined;
    }> = [];

    // Check if the response is valid
    if (true) {
      //    if (aijsonresponse.action_type === "proximity_search") {
      console.log("proximity_search");

      /*
        - `target_type`: Target establishment type (e.g., "women_apparel_store", "restaurant", etc.)
        - `max_distance`: Maximum distance, if a distance is not minimum or maxium use max_distance (numeric or null)
        - `min_distance`: Minimum distance (numeric or null)
        - `distance_unit`: Distance unit, must be chosen between "feet", "meters", "cm" and "mm" (string or null)
        - `is_within_distance`: Boolean (true = within the specified distance, false = outside)
        - `is_within_area`: Boolean (true = within the specified area, false = outside)
        - `availability`: Desired space status ("available", "any", etc.)
        - `min_area`: Minimum area (numeric or null)
        - `max_area`: Maximum area, if an area is not minimum or maxium use max_area (numeric or null)
        - `area_unit`: Area unit, must be chosen between "quare_feet", "squre_meters", "square_cm" and "square_mm" (string or null)
        - `target_name`: Target establishment name, shall always be present, null if not interpretated from the search string. If the brand is know then use the correct name of the brand as the target_name, for example: "UGG" was previously known as "Uggs", so use "UGG" as target_name, "Abercrombie" is more correct "Abercrombie & Fitch" and therefore use "Abercrombie & Fitch" as target_name
    */

      /*
        target_type = aijsonresponse.action_type;
        target_type = aijsonresponse.parameters.target_type;
        max_distance = aijsonresponse.parameters.max_distance;
        min_distance = aijsonresponse.parameters.min_distance;
        distance_unit = aijsonresponse.parameters.distance_unit;
        is_within_distance = aijsonresponse.parameters.is_within_distance;
        is_within_area = aijsonresponse.parameters.is_within_area;
        availability = aijsonresponse.parameters.availability;
        min_area = aijsonresponse.parameters.min_area;
        max_area = aijsonresponse.parameters.max_area;
        target_name = aijsonresponse.parameters.target_name;
        area_unit = aijsonresponse.parameters.area_unit;
      */

      // mango test case
      action_type = "proximity_search";
      target_type = "retail_store";
      target_name = "Mango";
      max_distance = "null";
      min_distance = "200";
      distance_unit = "feet";
      is_within_distance = false;
      availability = "available";
      min_area = 4000;
      max_area = 6000;
      area_unit = "square_feet";

      /*
          "action_type": "proximity_search",
         "parameters": {
         "target_type": "retail_store",
         "target_name": "Mango",
         "max_distance": null,
         "min_distance": 200,
         "distance_unit": "feet",
         "is_within_distance": false,
         "availability": "available",
         "min_area": 4000,
         "max_area": 6000,
         "area_unit": "square_feet"
      */

      // check 1 - find the target name
      // the ai may not return a target name, so we need to set it to the target type
      if (
        target_name !== "" &&
        target_name !== undefined &&
        target_name !== null
      ) {
        // do nothing , all good
      } else if (
        (target_name === "" ||
          target_name === undefined ||
          target_name === null) &&
        target_type !== "" &&
        target_type !== undefined &&
        target_type !== null
      ) {
        target_name = target_type;
      } else {
        console.log("NOTE: target name and traget type are both empty");
        return result;
      }

      target_name = target_name.toLowerCase();

      // check 2 - find all data for the target name
      console.log(
        "target_name before checking against plansInfo: ",
        target_name
      );
      result.targetPlanInfo = (plansInfo?.spaces ?? []).find(
        (planInfo: any) => planInfo["spaceHeader"].toLowerCase() === target_name
      );
      console.log("planInfo: ", result.targetPlanInfo);

      if (result.targetPlanInfo == undefined || result.targetPlanInfo == null) {
        console.log("NOTE: target name not found in plansInfo");
        return result;
      }
      // we now have a target name
      // we now can check area and distance

      if (result.targetPlanInfo) {
        thispace = result.targetPlanInfo["spaceNumber"]
          .replaceAll(".", "_")
          .replaceAll(" ", "_");

        // check the area
        for (const key in plansInfo?.spaces ?? []) {
          let myarea = plansInfo?.spaces[key].detailTabs[0].detail.GLA;

          console.log("myarea: ", myarea);

          if (myarea !== undefined) {
            let myareastring = myarea!.toString();
            myareastring = myareastring.replace(" m2", "");
            // Remove any commas
            myareastring = myareastring.replace(/,/g, "");
            myarea = parseFloat(myareastring);
          } else myarea = 0;

          // there can be no area indication in the JSON - the entire aray should be returned
          if (
            (min_area == undefined || min_area == null || min_area == 0) &&
            (max_area == undefined || max_area == null || max_area == 0)
          ) {
            myReturnArray.push({
              SpaceID: plansInfo?.spaces[key].spaceNumber,
              Area: myarea,
              Tenant: plansInfo?.spaces[key].spaceHeader,
            });
          }

          // there can be a min area indication in the JSON
          if (
            min_area !== undefined &&
            min_area !== null &&
            min_area !== 0 &&
            (max_area == undefined || max_area == null || max_area == 0)
          ) {
            if (myarea > min_area) {
              console.log("found area larger than min: ", myarea);
              myReturnArray.push({
                SpaceID: plansInfo?.spaces[key].spaceNumber,
                Area: myarea,
                Tenant: plansInfo?.spaces[key].spaceHeader,
              });
            }
          }

          // there can be a max area indication in the JSON
          if (
            min_area == undefined &&
            min_area == null &&
            min_area == 0 &&
            (max_area !== undefined || max_area !== null || max_area !== 0)
          ) {
            if (myarea < max_area) {
              console.log("found area less than max: ", myarea);
              myReturnArray.push({
                SpaceID: plansInfo?.spaces[key].spaceNumber,
                Area: myarea,
                Tenant: plansInfo?.spaces[key].spaceHeader,
              });
            }
          }

          // there can be a and min max area indication in the JSON
          if (
            min_area !== undefined &&
            min_area !== null &&
            min_area !== 0 &&
            (max_area !== undefined || max_area !== null || max_area !== 0)
          ) {
            if (myarea < max_area && myarea > min_area) {
              console.log("found area between min and max: ", myarea);
              myReturnArray.push({
                SpaceID: plansInfo?.spaces[key].spaceNumber,
                Area: myarea,
                Tenant: plansInfo?.spaces[key].spaceHeader,
              });
            }
          }
        }

        // we now have an array of spaces that are within the area
        console.log(
          "myReturnArray: ",
          myReturnArray,
          " we these spaces purple"
        );
        for (var key in myReturnArray) {
          cadviewer.cvjs_highlightSpace(
            myReturnArray[key].SpaceID ?? "",
            highlight_purple
          );
        }

        console.log("thisspace: ", thispace);

        // Check the distances
        const distanceInfo = (distanceData?.spaces ?? []).find(
          (distInfo: any) => distInfo["spaceNumber"] === thispace
        );

        console.log(
          "do we have distanceInfo for target space: ",
          distanceInfo,
          " min_distance: ",
          min_distance,
          " max_distance: ",
          max_distance
        );

        //*

        if (distanceInfo) {
          let thisdistance;
          const spaces = distanceInfo["distances"];

          for (const key2 in spaces ?? []) {
            thisdistance = spaces[key2].Distance;

            console.log(
              "thisdistance: ",
              thisdistance,
              " min_distance: ",
              min_distance,
              " max_distance: ",
              max_distance
            );

            console.log(
              min_distance == undefined ||
              min_distance == "null" ||
              min_distance == null ||
              min_distance == "0",
              max_distance == undefined ||
              max_distance == "null" ||
              max_distance == null ||
              max_distance == "0"
            );

            // there can be no area indication in the JSON - the entire aray should be returned
            if (
              (min_distance == undefined ||
                min_distance == "null" ||
                min_distance == null ||
                min_distance == "0") &&
              (max_distance == undefined ||
                max_distance == "null" ||
                max_distance == null ||
                max_distance == "0")
            ) {
              console.log("case1");

              myReturnArray2.push({
                SpaceID: spaces[key2].spaceNumber,
                Distance: thisdistance,
              });
            }

            console.log(
              min_distance !== undefined &&
              min_distance !== "null" &&
              min_distance !== null &&
              min_distance !== "0",
              max_distance == undefined ||
              max_distance == "null" ||
              max_distance == null ||
              max_distance == "0"
            );

            // there can be a min area indication in the JSON
            if (
              min_distance !== undefined &&
              min_distance !== "null" &&
              min_distance !== null &&
              min_distance !== "0" &&
              (max_distance == undefined ||
                max_distance == "null" ||
                max_distance == null ||
                max_distance == "0")
            ) {
              console.log("case2");
              let min_distance_number = parseFloat(min_distance);
              if (thisdistance > min_distance_number) {
                myReturnArray2.push({
                  SpaceID: spaces[key2].spaceNumber,
                  Distance: thisdistance,
                });
              }
            }

            console.log(
              min_distance == undefined ||
              min_distance == "null" ||
              min_distance == null ||
              min_distance == "0",
              max_distance !== undefined ||
              max_distance !== "null" ||
              max_distance !== null ||
              max_distance !== "0"
            );

            // there can be a max area indication in the JSON
            if (
              (min_distance == undefined ||
                min_distance == "null" ||
                min_distance == null ||
                min_distance == "0") &&
              (max_distance !== undefined ||
                max_distance !== "null" ||
                max_distance !== null ||
                max_distance !== "0")
            ) {
              console.log("case3");

              let max_distance_number = parseFloat(max_distance);
              if (thisdistance < max_distance_number) {
                myReturnArray2.push({
                  SpaceID: spaces[key2].spaceNumber,
                  Distance: thisdistance,
                });
              }
            }

            console.log(
              min_distance !== undefined &&
              min_distance !== "null" &&
              min_distance !== null &&
              min_distance !== "0",
              max_distance !== undefined &&
              max_distance !== "null" &&
              max_distance !== null &&
              max_distance !== "0"
            );

            // there can be a and min max area indication in the JSON
            if (
              min_distance !== undefined &&
              min_distance !== "null" &&
              min_distance !== null &&
              min_distance !== "0" &&
              max_distance !== undefined &&
              max_distance !== "null" &&
              max_distance !== null &&
              max_distance !== "0"
            ) {
              let min_distance_number = parseFloat(min_distance);
              let max_distance_number = parseFloat(max_distance);

              console.log("case4");

              if (
                thisdistance < max_distance_number &&
                thisdistance > min_distance_number
              ) {
                myReturnArray2.push({
                  SpaceID: spaces[key2].spaceNumber,
                  Distance: thisdistance,
                });
              }
            }
          }
        }

        // we now have an array of spaces that are within the distances
        console.log(
          "myReturnArray2: ",
          myReturnArray2,
          " we these spaces yellow"
        );
        for (var key in myReturnArray2) {
          cadviewer.cvjs_highlightSpace(
            myReturnArray2[key].SpaceID ?? "",
            highlight_yellow
          );
        }

        // now we combine the two arrays

        // Find matching spaces that meet both area and distance criteria
        for (const returnArrayKey in myReturnArray) {
          for (const returnArrayKey2 in myReturnArray2) {
            if (
              myReturnArray[returnArrayKey].SpaceID ===
              myReturnArray2[returnArrayKey2].SpaceID
            ) {
              console.log(
                "found match: ",
                myReturnArray[returnArrayKey].SpaceID,
                " ",
                myReturnArray2[returnArrayKey2].SpaceID
              );

              /*
              cadviewer.cvjs_highlightSpace(
                myReturnArray2[returnArrayKey2].SpaceID ?? "",
                highlight_green
              );
              */

              /*
              result.searchResults.push({
                spaceID: myReturnArray[returnArrayKey].SpaceID,
                area: myReturnArray[returnArrayKey].Area,
                tenant: myReturnArray[returnArrayKey].Tenant,
                distance: myReturnArray2[returnArrayKey2].Distance,
              });
              */
            }
          }
        }

        //*/
      }
    }
  }, [currentCanvasInstance, plansInfo, distanceData]);

  const netfiles01 = useCallback(() => {
    // save all content
    // save sticky notes and redlines

    var FileName =
      "https://vue6.netfiles.dev/nf/api/v1/cvd/download-svg/neubalan.svg";

    cadviewer.cvjs_LoadDrawing(currentCanvasInstance as string, FileName);
  }, [currentCanvasInstance]);

  const hyphen04 = useCallback(() => {
    // save all content
    // save sticky notes and redlines

    var FileName =
      "http://localhost:3000" +
      "/content/custom/hyphen.com/American Farmhouse 201225 full.pdf";

    cadviewer.cvjs_LoadDrawing(currentCanvasInstance as string, FileName);
  }, [currentCanvasInstance]);

  const hyphen02 = useCallback(() => {
    // save all content
    // save sticky notes and redlines
    cadviewer.cvjs_setStickyNoteSaveRedlineUrl(
      //        ServerBackEndUrl + "/content/redlines/" + "v7/" + "test01.json"
      "/content/redlines/" + "v7/" + "test_red02.json"
    );
    console.log(
      "ServerBackEndUrl + /content/redlines/ + v7/ + test_red02.json=" +
      config.ServerBackEndUrl +
      "/content/redlines/" +
      "v7/" +
      "test_red02.json"
    );
    cadviewer.cvjs_saveStickyNotesRedlines("floorPlan", false, "");
    // save image notes
    cadviewer.cvjs_saveAllImageLinks("floorPlan", ""); //save

    //*/
    //*
    // save space objects
    cadviewer.cvjs_saveSpaceObjects(
      "floorPlan",
      "/content/spaceObjects/" + "hyphen02/" + "spaces_test02.json",
      ""
    );
  }, [currentCanvasInstance]);

  const hyphen03 = useCallback(() => {
    //*
    // load all content

    // load sticky notes and redlines
    cadviewer.cvjs_setStickyNoteRedlineUrl(
      config.ServerBackEndUrl + "/content/redlines/" + "v7/" + "test_red02.json"
      //    "/content/redlines/" + "v7/" + "test_red01.json"
    );

    console.log(
      "ServerBackEndUrl + /content/redlines/ + v7/ + test_red02.json=" +
      config.ServerBackEndUrl +
      "/content/redlines/" +
      "v7/" +
      "test_red02.json"
    );
    cadviewer.cvjs_loadStickyNotesRedlines("floorPlan", "");
    //*/
    // load image notes
    cadviewer.cvjs_loadAllImageLinks("floorPlan", ""); //save
    // load space objects
    cadviewer.cvjs_loadSpaceObjectsDirect(
      "floorPlan",
      config.ServerBackEndUrl +
      "/content/spaceObjects/" +
      "hyphen02/" +
      "spaces_test02.json"
    );
  }, [currentCanvasInstance]);

  const customcommand01 = useCallback(() => {
    //      cadviewer.cvjs_customCommand_01();
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod06 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_click(
      generic_make_rect_arrow_mousemove_method,
      generic_make_rect_arrow_mousedown_method,
      generic_make_rect_arrow_mouseup_method,
      generic_make_rect_arrow_dblclick_method,
      generic_make_rect_arrow_init_method
    );
  }, [currentCanvasInstance]);

  const cadviewerCanvasMethod07 = useCallback(() => {
    cadviewer.cvjs_executeCustomCanvasMethod_click(
      generic_handles_mousemove_method_01,
      generic_handles_mousedown_method_01,
      generic_handles_mouseup_method_01,
      generic_handles_dblclick_method_01,
      generic_handles_init_method_01
    );
  }, [currentCanvasInstance]);

  ///// DRAG + CLICK ON CANVAS  - CONSOLE

  /**
   * Template start drag method for custom canvas
   */

  var generic_start_method_01 = function () {
    console.log("generic_start_method_01");
  };

  /**
   * Template move drag method for custom canvas
   */
  var generic_move_method_01 = function (
    dx: number,
    dy: number,
    x: number,
    y: number
  ) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);
    console.log(
      "generic_move_method_01: dx=" +
      dx +
      " dy=" +
      dy +
      " x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  /**
   * Template stop drag method for custom canvas
   */
  var generic_stop_method_01 = function () {
    cadviewer.cvjs_removeCustomCanvasMethod();
    console.log("REMOVE: generic_stop_method_01");
  };

  /**
   * Template mouse-move method for custom canvas
   */

  var generic_mousemove_method_01 = function (e: any, x: number, y: number) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    //cadviewer.cvjs_removeCustomCanvasMethod();
    console.log(
      "generic_mousemove_method_01: x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  /**
   * Template mouse-down method for custom canvas
   */

  var generic_mousedown_method_01 = function (e: any, x: number, y: number) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    //cadviewer.cvjs_removeCustomCanvasMethod();
    console.log(
      "generic_mousedown_method_01: x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  /**
   * Template mouse-up method for custom canvas
   */

  var generic_mouseup_method_01 = function (e: any, x: number, y: number) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    console.log(
      "generic_mouseup_method_01: x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  /**
   * Template double-click method for custom canvas
   */

  var generic_dblclick_method_01 = function (e: any, x: number, y: number) {
    cadviewer.cvjs_removeCustomCanvasMethod();

    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);
    console.log(
      "REMOVE: generic_dblclick_method_01: x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  ///// DRAG + CLICK ON CANVAS  - CONSOLE

  // SAMPLE TO CREATE RECTANGLE BY CLICK

  var generic_make_rect_init_method = function () {
    console.log("generic_make_rect_init_method");
    generic_canvas_flag_first_click_rectangle = false;
    generic_canvas_flag_rectangle = false;
  };

  var generic_make_rect_mousedown_method = function (
    e: any,
    x: number,
    y: number
  ) {
    try {
      console.log("generic_make_rect_mousedown_method");

      if (!generic_canvas_flag_first_click_rectangle) {
        var tPath_r = "M" + 0 + "," + 0;
        cvjs_RubberBand = cadviewer
          .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
          .attr({ stroke: "#b00000", fill: "none", "stroke-width": 0.5 });
        generic_canvas_flag_first_click_rectangle = true;
        generic_canvas_flag_rectangle = false;
        console.log("rubberband");
      } else {
        console.log(
          generic_canvas_flag_first_click_rectangle +
          "  " +
          generic_canvas_flag_rectangle
        );
        if (generic_canvas_flag_rectangle) {
          generic_make_rect_stop_method();
        }
      }
    } catch (err) {
      console.log(err);
    }
    //console.log("mouse down ");
  };

  var generic_make_rect_mouseup_method = function () {
    try {
      console.log("generic_make_rect_mouseup_method");
    } catch (err) {
      console.log(err);
    }
  };

  var generic_make_rect_dblclick_method = function () {
    try {
      console.log("generic_make_rect_dblclick_method");
    } catch (err) {
      console.log(err);
    }
  };

  var generic_make_rect_mousemove_method = function (
    e: any,
    x: number,
    y: number
  ) {
    try {
      if (generic_canvas_flag_first_click_rectangle) {
        cadviewer.cvjs_customCanvasMethod_globalScale();
        if (!generic_canvas_flag_rectangle) {
          cvjs_firstX = cadviewer.cvjs_SVG_x(x);
          cvjs_firstY = cadviewer.cvjs_SVG_y(y);
          cvjs_lastX = cvjs_firstX;
          cvjs_lastY = cvjs_firstY;
          generic_canvas_flag_rectangle = true;
        } else {
          // we cannot have the mouse directly on top of the rubberband path, then it will not respond
          var mousedelta = 2;
          cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
          cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
        }

        tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
        cvjs_RubberBand.attr({ path: tPath_r });
      }
    } catch (err) {
      console.log(err);
    }
  };

  var generic_make_rect_stop_method = function () {
    // find the current highest node number
    var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
    var Node_id = parseInt(Node);
    if (isNaN(Node_id)) {
      Node_id = 1;
    }

    Node_id++;
    var currentNode_underbar = "Node_" + Node_id;

    window.alert("generic_make_rect_stop_method " + currentNode_underbar);

    var loadSpaceImage_ID = JQ("#image_ID").val() as string;
    var loadSpaceImage_Type = JQ("#image_Type").val() as string;
    var loadSpaceImage_Layer = "cvjs_SpaceLayer";

    // create a group with space as main object
    cadviewer.cvjs_createSpaceObjectGroup(
      currentNode_underbar,
      cvjs_RubberBand,
      loadSpaceImage_ID,
      loadSpaceImage_ID,
      loadSpaceImage_Type,
      loadSpaceImage_Layer,
      "myGroup"
    );

    // make an equal rect, but with the proper color settings and controls
    var grayBox = cadviewer
      .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
      .attr({
        fill: "#808080",
        "fill-opacity": "1.0",
        stroke: "#000",
        "stroke-opacity": "1.0",
        "stroke-width": 0.5,
      });
    cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
      currentNode_underbar,
      grayBox,
      "rect01"
    );

    cadviewer.cvjs_removeCustomCanvasMethod();
  };

  // END - SAMPLE TO CREATE RECTANGLE BY CLICK

  // SAMPLE TO CREATE RECTANGLE BY DRAG

  var generic_drag_rect_start = function () {
    generic_canvas_flag_first_click_rectangle = true;
    generic_canvas_flag_rectangle = false;

    var tPath_r = "M" + 0 + "," + 0;
    cvjs_RubberBand = cadviewer
      .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
      .attr({ stroke: "#b00000", fill: "none" });

    console.log("generic_start_method_01");
  };

  /**
   * Template move drag method for custom canvas
   */
  var generic_drag_rect_move = function (
    dx: number,
    dy: number,
    x: number,
    y: number
  ) {
    try {
      if (generic_canvas_flag_first_click_rectangle) {
        cadviewer.cvjs_customCanvasMethod_globalScale();
        if (!generic_canvas_flag_rectangle) {
          cvjs_firstX = cadviewer.cvjs_SVG_x(x);
          cvjs_firstY = cadviewer.cvjs_SVG_y(y);
          cvjs_lastX = cvjs_firstX;
          cvjs_lastY = cvjs_firstY;
          generic_canvas_flag_rectangle = true;
        } else {
          // we cannot have the mouse directly on top of the rubberband path, then it will not respond
          var mousedelta = 1;
          cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
          cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
        }

        var tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
        cvjs_RubberBand.attr({ path: tPath_r });
      }
    } catch (err) {
      console.log(err);
    }
  };

  /**
   * Template stop drag method for custom canvas
   */
  var generic_drag_rect_stop = function () {
    cvjs_RubberBand.attr({
      fill: "#99ff99",
      "fill-opacity": "0.5",
      stroke: "#ff9999",
      "stroke-opacity": "1",
    });
    cadviewer.cvjs_removeCustomCanvasMethod();
    console.log("REMOVE: generic_drag_rect_stop");
  };

  // END - SAMPLE TO CREATE RECTANGLE BY DRAG

  // SAMPLE TO DRAG RECTANGLE if overlapping space objects

  var select_drag_rect_start = function () {
    generic_canvas_flag_first_click_rectangle = true;
    generic_canvas_flag_rectangle = false;

    var tPath_r = "M" + 0 + "," + 0;
    cvjs_RubberBand = cadviewer
      .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
      .attr({
        fill: "#ff9999",
        "fill-opacity": "0.5",
        stroke: "#ff9999",
        "stroke-opacity": "1",
      });

    console.log("generic_start_method_01");
  };

  var select_drag_rect_move = function (
    dx: number,
    dy: number,
    x: number,
    y: number
  ) {
    try {
      if (generic_canvas_flag_first_click_rectangle) {
        cadviewer.cvjs_customCanvasMethod_globalScale();
        if (!generic_canvas_flag_rectangle) {
          cvjs_firstX = cadviewer.cvjs_SVG_x(x);
          cvjs_firstY = cadviewer.cvjs_SVG_y(y);
          cvjs_lastX = cvjs_firstX;
          cvjs_lastY = cvjs_firstY;
          generic_canvas_flag_rectangle = true;
        } else {
          // we cannot have the mouse directly on top of the rubberband path, then it will not respond
          var mousedelta = 1;
          cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
          cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
        }

        var tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
        cvjs_RubberBand.attr({ path: tPath_r });
      }
    } catch (err) {
      console.log(err);
    }
  };

  var select_drag_rect_stop = function () {
    cvjs_RubberBand.attr({ path: "M0,0" });
    var mybox;
    var overlap;
    var selected_list = "";

    // reorder x,  if not dragged left to right, top to buttom
    var temp;
    if (cvjs_firstX > cvjs_lastX) {
      temp = cvjs_firstX;
      cvjs_firstX = cvjs_lastX;
      cvjs_lastX = temp;
    }
    // reorder y,  if not dragged left to right, top to buttom
    if (cvjs_firstY > cvjs_lastY) {
      temp = cvjs_firstY;
      cvjs_firstY = cvjs_lastY;
      cvjs_lastY = temp;
    }

    // get all spaces
    var spaceObjectIds = cadviewer.cvjs_getSpaceObjectIdList();
    // loop over all spaces
    for (var spc in spaceObjectIds) {
      // get the bounding box of the space

      mybox = cadviewer.cvjs_getSpaceObjectBoundingBox(spaceObjectIds[spc]);
      // check if it operlaps with the drag rectangle
      if (mybox == false) continue;

      //console.log(cvjs_firstX+"  "+ cvjs_firstY+" "+ cvjs_lastX+ " "+ cvjs_lastY+"  "+spc);
      //console.log(mybox.x+" "+ mybox.y+" "+ (mybox.x+mybox.width) + " "+ (mybox.y+mybox.height));

      overlap = cadviewer.cvjs_rect_doOverlap(
        cvjs_firstX,
        cvjs_firstY,
        cvjs_lastX,
        cvjs_lastY,
        mybox.x,
        mybox.y,
        mybox.x + mybox.width,
        mybox.y + mybox.height
      );

      if (overlap) selected_list += spaceObjectIds[spc] + ";";
    }

    if (selected_list == "") selected_list = "None";

    window.alert("Selected Objects: " + selected_list);
    //cvjs_RubberBand.attr({fill: '#99ff99', "fill-opacity": "0.5", stroke: '#ff9999', 'stroke-opacity': "1"});
    cadviewer.cvjs_removeCustomCanvasMethod();
    console.log("REMOVE: generic_drag_rect_stop");
  };

  // END - SAMPLE TO DRAG RECTANGLE if overlapping space objects

  // 2025-04-11
  // custom class to highlight selected objects

  var select_drag_rect_stop_highlight = function () {
    cvjs_RubberBand.attr({ path: "M0,0" });
    var mybox;
    var overlap;
    var selected_list = "";

    // reorder x,  if not dragged left to right, top to buttom
    var temp;
    if (cvjs_firstX > cvjs_lastX) {
      temp = cvjs_firstX;
      cvjs_firstX = cvjs_lastX;
      cvjs_lastX = temp;
    }
    // reorder y,  if not dragged left to right, top to buttom
    if (cvjs_firstY > cvjs_lastY) {
      temp = cvjs_firstY;
      cvjs_firstY = cvjs_lastY;
      cvjs_lastY = temp;
    }

    selectedList = [];

    // get all spaces
    var spaceObjectIds = cadviewer.cvjs_getSpaceObjectIdList();
    // loop over all spaces
    for (var spc in spaceObjectIds) {
      // get the bounding box of the space

      mybox = cadviewer.cvjs_getSpaceObjectBoundingBox(spaceObjectIds[spc]);
      // check if it operlaps with the drag rectangle
      if (mybox == false) continue;

      //console.log(cvjs_firstX+"  "+ cvjs_firstY+" "+ cvjs_lastX+ " "+ cvjs_lastY+"  "+spc);
      //console.log(mybox.x+" "+ mybox.y+" "+ (mybox.x+mybox.width) + " "+ (mybox.y+mybox.height));

      overlap = cadviewer.cvjs_rect_doOverlap(
        cvjs_firstX,
        cvjs_firstY,
        cvjs_lastX,
        cvjs_lastY,
        mybox.x,
        mybox.y,
        mybox.x + mybox.width,
        mybox.y + mybox.height
      );

      if (overlap) {
        selected_list += spaceObjectIds[spc] + ";";
        selectedList.push(spaceObjectIds[spc]);
      }
    }

    // Sync selectedList with context
    setMultiSelectArray(selectedList);

    if (selected_list == "") selected_list = "None";

    console.log(
      //window.alert(
      "Selected Objects: " +
      selected_list +
      " selectedList.length" +
      selectedList.length
    );

    //10.95.14
    //cvjs_RubberBand.attr({fill: '#99ff99', "fill-opacity": "0.5", stroke: '#ff9999', 'stroke-opacity': "1"});
    cadviewer.cvjs_removeCustomCanvasMethod();
    cadviewer.cvjs_updateMultiSelectArray(selectedList);

    /*

    var highlight_green = {
      fill: "#32CD32", // 0dff8a
      "fill-opacity": 0.8,
      stroke: "#228B22", // 0dff8a green
      "stroke-width": 2.0,
      "stroke-opacity": 1,
      "stroke-linejoin": "round",
    };



    var cvjsRoomPolygonHighlightAttributes = {
            fill: '#Ffa500' , //'#00F', //'#F4d7f4', //'#a4d7f4',
            "fill-opacity": 0.3,
            stroke: '#7B3804', //'#00F', // '#a4d7f4',
            'stroke-width': 2.5, //0.2,
            'stroke-linejoin': 'round',
            'stroke-opacity': 1.0,
          };


    var cvjsRoomPolygonSelectAttributes = {
            fill: '#F00', //'#5BFEF6', //'#5BBEF6',
            "fill-opacity": 0.3,
            stroke: '#5B0303', //'#5BBEF6',
            'stroke-linejoin': 'round',
            'stroke-width': 4, //0.23,
            'stroke-opacity': 1.0,
          };


    for (var i = 0; i < selectedList.length; i++) {
//      cadviewer.cvjs_highlightSpace(selectedList[i], cvjsRoomPolygonSelectAttributes);
      cadviewer.cvjs_setSpaceObjectHighlightStyle(selectedList[i], highlight_blue_borders, mouseover_state, mouseover_state);
    }
*/
    // add to multi select array in context

    console.log("REMOVE: generic_drag_rect_stop");
  };

  // SAMPLE TO CREATE RECTANGLE w TEXT and ARRow BY CLICK

  var logic_flags = [false, false, false, false, false, false];
  var operation_type = "";
  var mybasewidth = 1;

  var generic_make_rect_arrow_init_method = function () {
    console.log("generic_make_rect_init_method");
    logic_flags = [false, false, false, false, false, false];
    operation_type = "box";
  };

  var tPath_r = "";

  var generic_make_rect_arrow_mousedown_method = function (
    e: any,
    x: number,
    y: number
  ) {
    try {
      if (
        operation_type.indexOf("arrow") == 0 &&
        logic_flags[0] &&
        logic_flags[1]
      ) {
        generic_make_rect_arrow_stop_method2();
      }

      if (operation_type.indexOf("box") == 0 && !logic_flags[0]) {
        // first box
        var tPath_r = "M" + 0 + "," + 0;
        cvjs_RubberBand = cadviewer
          .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
          .attr({ stroke: "#b00000", fill: "none" });
        logic_flags[0] = true;
        logic_flags[1] = false;
      }
      if (
        operation_type.indexOf("box") == 0 &&
        logic_flags[0] &&
        logic_flags[1]
      ) {
        generic_make_rect_arrow_stop_method1();
      }
    } catch (err) {
      console.log(err);
    }
    //console.log("mouse down ");
  };

  var generic_make_rect_arrow_mouseup_method = function () {
    try {
      console.log("generic_make_rect_mouseup_method");
    } catch (err) {
      console.log(err);
    }
  };

  var generic_make_rect_arrow_dblclick_method = function () {
    try {
      console.log("generic_make_rect_dblclick_method");
    } catch (err) {
      console.log(err);
    }
  };

  var generic_make_rect_arrow_mousemove_method = function (
    e: any,
    x: number,
    y: number
  ) {
    try {
      if (operation_type.indexOf("box") == 0 && logic_flags[0]) {
        cadviewer.cvjs_customCanvasMethod_globalScale();
        if (!logic_flags[1]) {
          cvjs_firstX = cadviewer.cvjs_SVG_x(x);
          cvjs_firstY = cadviewer.cvjs_SVG_y(y);
          cvjs_lastX = cvjs_firstX;
          cvjs_lastY = cvjs_firstY;
          logic_flags[1] = true;
        } else {
          // we cannot have the mouse directly on top of the rubberband path, then it will not respond
          var mousedelta = 1;
          cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
          cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);
        }

        tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_firstX + "," + cvjs_firstY + " Z";
        cvjs_RubberBand.attr({ path: tPath_r });
      }

      if (operation_type.indexOf("arrow") == 0 && logic_flags[0]) {
        cadviewer.cvjs_customCanvasMethod_globalScale();

        logic_flags[1] = true;
        var mousedelta = 1;
        cvjs_lastX = cadviewer.cvjs_SVG_x(x - mousedelta);
        cvjs_lastY = cadviewer.cvjs_SVG_y(y - mousedelta);

        tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
        tPath_r += "L" + cvjs_lastX + "," + cvjs_lastY;
        cvjs_RubberBand.attr({ path: tPath_r });
      }
    } catch (err) {
      console.log(err);
    }
  };

  var randomNr = 0;

  var generic_make_rect_arrow_stop_method1 = function () {
    // find the current highest node number
    var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
    var Node_id = parseInt(Node);
    if (isNaN(Node_id)) {
      Node_id = 1;
    }

    Node_id++;
    var currentNode_underbar = "Node_" + Node_id;

    randomNr = Math.floor(Math.random() * Math.floor(100000));
    window.alert("randomNr " + randomNr);

    cvjs_RubberBand.attr({
      fill: "none",
      "fill-opacity": "0.5",
      stroke: "#0000b0",
      "stroke-opacity": "1",
    });
    // create a group with space as main object
    cadviewer.cvjs_createSpaceObjectGroup(
      currentNode_underbar,
      cvjs_RubberBand,
      "API" + randomNr,
      "API" + randomNr,
      "Generic",
      "myLayer",
      "myGroup"
    );

    // create a new border object as separate graphics - we use the rubberband as our graphics variable
    cvjs_RubberBand = cadviewer
      .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
      .attr({
        fill: "none",
        "fill-opacity": "1",
        stroke: "#000",
        "stroke-opacity": "1",
        "stroke-width": mybasewidth,
      });
    cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
      currentNode_underbar,
      cvjs_RubberBand,
      "rect01"
    );

    // create the text string add add to graphics group
    var myText = cadviewer
      .cvjs_makeTextObjectOnCanvas(
        cvjs_firstX + (cvjs_lastX - cvjs_firstX) / 10.0,
        cvjs_lastY - (cvjs_lastY - cvjs_firstY) / 5.0,
        "API" + randomNr
      )
      .attr({
        fill: "#000",
        "fill-opacity": "1",
        stroke: "#000",
        "font-size": Math.abs(cvjs_lastY - cvjs_firstY) / 2.0,
      });
    cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
      currentNode_underbar,
      myText,
      "text01"
    );

    // we change to arrow, and directly make the mouse draggable
    operation_type = "arrow";
    logic_flags[0] = true;
    logic_flags[1] = false;

    // set rubberband to middle of box side
    cvjs_firstX = (cvjs_firstX + cvjs_lastX) / 2.0;
    cvjs_firstY = cvjs_lastY;
    // make new rubberband
    tPath_r = "M" + cvjs_firstX + "," + cvjs_firstY;
    cvjs_RubberBand = cadviewer
      .cvjs_makeGraphicsObjectOnCanvas("Path", tPath_r)
      .attr({ stroke: "#b00000", fill: "none" });
  };

  var generic_make_rect_arrow_stop_method2 = function () {
    cvjs_RubberBand.attr({
      fill: "none",
      "fill-opacity": "1",
      stroke: "#000",
      "stroke-opacity": "1",
      "stroke-width": mybasewidth,
    });
    // we create an arrow object and add to space object

    // here we have to add the graphical object to our already created object
    var Node = cadviewer.cvjs_currentMaxSpaceNodeId();
    var Node_id = parseInt(Node);
    if (isNaN(Node_id)) {
      Node_id = 1;
    }

    var currentNode_underbar = "Node_" + Node_id;

    cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
      currentNode_underbar,
      cvjs_RubberBand,
      "arrow-line01"
    );

    // create an arrow
    var angleInDegrees =
      (Math.atan2(cvjs_lastY - cvjs_firstY, cvjs_lastX - cvjs_firstX) /
        Math.PI) *
      180.0;
    var scaleTriangle = mybasewidth; // same as stroke-width
    var triangle_design =
      -5.0 * scaleTriangle +
      "," +
      5.5 * scaleTriangle +
      " " +
      0.0 * scaleTriangle +
      "," +
      -4.5 * scaleTriangle +
      " " +
      5.0 * scaleTriangle +
      "," +
      5.5 * scaleTriangle;
    var mysin = Math.sin((angleInDegrees / 180) * Math.PI);
    var mycos = Math.cos((angleInDegrees / 180) * Math.PI);
    var Ttrans =
      "r" +
      (angleInDegrees - 270) +
      "T" +
      (cvjs_lastX + mycos * scaleTriangle) +
      "," +
      cvjs_lastY;
    var Triangle = cadviewer.cvjs_makeGraphicsObjectOnCanvas(
      "Polyline",
      triangle_design
    );
    Triangle.attr({
      fill: "none",
      "fill-opacity": "1",
      stroke: "#000",
      "stroke-opacity": "1",
      "stroke-width": mybasewidth,
    });
    Triangle.attr({
      fill: "#000",
      transform: Ttrans,
    });

    // here we add an arrow to the object
    cadviewer.cvjs_addGraphicsToSpaceObjectGroup(
      currentNode_underbar,
      Triangle,
      "arrow01"
    );

    /*


  //NOTE:  IF THE CADViewer callback method is not exported from this component, then we need to catch it
  try {
//		this.cvjs_graphicalObjectOnChange(
            CV.cvjs_graphicalObjectOnChange(
      "Create",
      "CustomObject",
      "API" + randomNr
    );
  } catch (err) {
    console.log("cvjs_graphicalObjectOnChange: arrow method:" + err);
  }
  cadviewer.cvjs_removeCustomCanvasMethod();


    */
  };

  // END OF DRAG

  // CLICK TO SELECT HANDLES

  // NOTE  - for Handles to be processed in DWG conversion, the conversion parameter -hlall  must be set:
  // USE THIS FOR PROCESSING AUTOCAD HANDLES
  // include this:         cadviewer.cvjs_conversion_addAXconversionParameter("hlall", "");

  // USE THESE TO PROCESS LAYERS RM_ AND RM_TXT FOR INTERACTIVE HIGHLIGHT
  // optional:       cadviewer.cvjs_conversion_addAXconversionParameter("rl", "RM_");
  // optional:		cadviewer.cvjs_conversion_addAXconversionParameter("tl", "RM_TXT");

  var generic_handles_init_method_01 = function () {
    selected_handles = [];
    // we want to send click object to back!!!!!!
    // so we can click on Handle Objects
    cadviewer.cvjs_sendCustomCanvasToBack("floorPlan");
    handle_selector = true;
  };

  /**
   * Template mouse-move method for custom canvas
   */

  var generic_handles_mousemove_method_01 = function (
    e: any,
    x: number,
    y: number
  ) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    //cadviewer.cvjs_removeCustomCanvasMethod();
    // console.log("generic_mousemove_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
  };

  /**
   * Template mouse-down method for custom canvas
   */

  var generic_handles_mousedown_method_01 = function (
    e: any,
    x: number,
    y: number
  ) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    // cadviewer.cvjs_removeCustomCanvasMethod();
    // onsole.log("generic_mousedown_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
  };

  /**
   * Template mouse-up method for custom canvas
   */

  var generic_handles_mouseup_method_01 = function (
    e: any,
    x: number,
    y: number
  ) {
    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);

    // console.log("generic_mouseup_method_01: x="+x+" y="+y+" svg_x="+svg_x+"  svg_y="+svg_y);
  };

  /**
   * Template double-click method for custom canvas
   */

  var generic_handles_dblclick_method_01 = function (
    e: any,
    x: number,
    y: number
  ) {
    cadviewer.cvjs_removeCustomCanvasMethod();
    handle_selector = false;

    var mystring = "";
    for (var spc in selected_handles) {
      // we find all handles
      mystring += selected_handles[spc].handle + ";";
      // we need to clean out highlighted handles
      cadviewer.cvjs_mouseout_handleObjectStyles(
        selected_handles[spc].id,
        selected_handles[spc].handle
      );
    }

    window.alert(mystring);

    var svg_x = cadviewer.cvjs_SVG_x(x);
    var svg_y = cadviewer.cvjs_SVG_y(y);
    console.log(
      "REMOVE: generic_dblclick_method_01: x=" +
      x +
      " y=" +
      y +
      " svg_x=" +
      svg_x +
      "  svg_y=" +
      svg_y
    );
  };

  // END - SAMPLE TO DRAG RECTANGLE over HANDLES

  /////////  CANVAS CONTROL METHODS END

  /*


        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}              
                onClick={cadviewerCanvasMethod01}
        >
          Canvas-DRAG (console)
        </button>



                        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
                onClick={cadviewerCanvasMethod02}
        >
          Canvas-CLICK (console)
        </button>




        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
                onClick={cadviewerCanvasMethod03}
        >
          Make Rect -CLICK
        </button>




        <button
           className={`
                     bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                     ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                 `}
                 onClick={cadviewerCanvasMethod04}
        >
          Make Rect -DRAG
        </button>



        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
                onClick={cadviewerCanvasMethod05}
        >
          Select Spaces -DRAG (rl/tl in ax2025)
        </button>



        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
                onClick={cadviewerCanvasMethod06}
        >
          Make Box/Arrow Canvas-CLICK
        </button>


        <button className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small" ? " text-xs my-1 mr-1 py-[2px] px-1" : config.helperMethodsActionSize === "large" ? " text-base my-2 mr-2 py-2 px-3" : " text-sm my-2 mr-2 py-1 px-3"}
                `}
                onClick={cadviewerCanvasMethod07}
        >
          Select Handles -CLICK (DblClick End) (hlall in ax2025)
        </button>



*/

  return (
    <>
      <strong
        className={`
                    bg-white text-black font-normal rounded 
                    ${config.helperMethodsActionSize === "small"
            ? " text-xs my-1 mr-1 py-[2px] px-1"
            : config.helperMethodsActionSize === "large"
              ? " text-base my-2 mr-2 py-2 px-3"
              : " text-sm my-2 mr-2 py-1 px-3"
          }
                `}
      >
        AI Space Selection (Shift+Click to select/de-select a Storefront) :&nbsp;
      </strong>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small"
            ? " text-xs my-1 mr-1 py-[2px] px-1"
            : config.helperMethodsActionSize === "large"
              ? " text-base my-2 mr-2 py-2 px-3"
              : " text-sm my-2 mr-2 py-1 px-3"
          }
                `}
        onClick={cadviewerCanvasMethod05A}
      >
        Drag to Select Spaces for AI
      </button>


      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small"
            ? " text-xs my-1 mr-1 py-[2px] px-1"
            : config.helperMethodsActionSize === "large"
              ? " text-base my-2 mr-2 py-2 px-3"
              : " text-sm my-2 mr-2 py-1 px-3"
          }
                `}
        onClick={cadviewerCanvasVizquery01}
      >
        Clear Selected Spaces
      </button>




      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${config.helperMethodsActionSize === "small"
            ? " text-xs my-1 mr-1 py-[2px] px-1"
            : config.helperMethodsActionSize === "large"
              ? " text-base my-2 mr-2 py-2 px-3"
              : " text-sm my-2 mr-2 py-1 px-3"
          }
                `}
        onClick={cadviewerCanvasVizquery01X}
      >
        deselect 1848
      </button>





    </>
  );
}; /* BLOCKED METHODS AFTER THIS LINE - everything below is now commented out



      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery01A}
      >
        Show MultiSelected Spaces
      </button>




      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery01B}
      >
        Show MultiSelected and Drag Seleted Spaces
      </button>





      <strong
        className={`
                    bg-white text-black font-normal rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
      >
        Not used methods after this:&nbsp;
      </strong>








      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery02}
      >
        Lasso Spaces - all
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery03}
      >
        Lasso Spaces - inside
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery04}
      >
        Bottom Pane Off
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery05}
      >
        Bottom Pane On
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery06}
      >
        Init Multiselect
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery07}
      >
        Multiselect Action
      </button>


      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={hyphen02}
      >
        hyphen02 -save
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={hyphen03}
      >
        hyphen03 -load
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={hyphen04}
      >
        hyphen04 -load American Farm
      </button>

      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={cadviewerCanvasVizquery09}
      >
        AI response parsing
      </button>
      <button
        className={`
                    bg-primary-500 hover:bg-primary-700 text-white font-semibold rounded 
                    ${
                      config.helperMethodsActionSize === "small"
                        ? " text-xs my-1 mr-1 py-[2px] px-1"
                        : config.helperMethodsActionSize === "large"
                        ? " text-base my-2 mr-2 py-2 px-3"
                        : " text-sm my-2 mr-2 py-1 px-3"
                    }
                `}
        onClick={netfiles01}
      >
        Netfiles.de
      </button>
    </>
  );
}; */
